module.exports = __webpack_public_path__ + "static/media/b-2.d9455238.jpg";